<template>
  <div id="gallery">
      <div class="vx-row mb-12">
        <div class="vx-col w-full">
          <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-sending="sendingEvent" v-on:vdropzone-complete="successUpload"></vue-dropzone>
        </div>
      </div>
      <div class="vx-row mb-12">
        <div class="vx-col w-full">
          <vs-row vs-justify="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="3" v-for="(image,index) in imagesList" :key="index">
              <vs-card>
                <div class="cardx" slot="media">
                  <img class="zoom" :src="imagesPath+image" @click="copyToClipBoard(imagesPath+image)">
                </div>                
              </vs-card>
            </vs-col>
          </vs-row>
        </div>
      </div>      
  </div>
</template>

<script>
import axios from "@/axios.js"
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  components: {
    'vue-dropzone': vue2Dropzone
  },
  data() {
    let data = {
      imagesPath: 'https://crm.evblock.com/resources/blog/images/',
      imagesList: [],
      dropzoneOptions: {
          url: 'https://crm.evblock.com/api/gallery',
          thumbnailWidth: 150,
          maxFilesize: 100,
          paramName: 'document',
          withCredentials: true,
          uploadMultiple: true,
          //headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          //autoProcessQueue: false
      },      
    }
    return data;
  },
  created(){
    this.setData();
  },
  computed: {},
  methods: {
    copyToClipBoard: function(value){
        let that = this;
        let text = value;
        let textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        if(document.execCommand('copy'))
              that.$vs.notify({ color: 'success', title: 'copied to clipboard'})
        document.body.removeChild(textArea);
    },
    setData: function(){
        let that = this;
        axios.get("https://crm.evblock.com/api/gallery")
        .then((response) => {    
          that.imagesList.splice(0);
          for(let i in response.data){
            that.imagesList.push(response.data[i]);
          }          
        })
        .catch(() => {  })
    },
    sendingEvent (file, xhr, formData) {
        formData.append('type', 'file-upload');
    },
    uploadFile: function(){
      this.$refs.myVueDropzone.processQueue();
    },
    reset: function(){
      this.$refs.myVueDropzone.removeAllFiles();
    },
    successUpload(response) {
        let res = JSON.parse(response.xhr.response);
        if(res[0].out1==='done!' || this.successStatuses.indexOf(res[0].out1)!==-1){
          this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'File uploaded' })
          this.reset();
          this.setData();
        } else
          this.$vs.notify({ color: 'danger', title: 'Failed', text: res[0].out1 })
    },
    translate: function(key){
      return this.$t(key);
    }
  },
  mounted() {

  }
}

</script>
<style scoped>
.cardx {
  margin: 15px;
}

.zoom:hover {
  transform: scale(1.5); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
</style>